import { useMutation, useQuery } from "@tanstack/react-query";
import {
  startRetrievalTest,
  getRetrievalTestStatus,
  RetrievalTestStatusResponse,
  startGridSearch,
  getGridSearchStatus,
  GridSearchStatusResponse,
} from "../Api/retrievalTest";

export const useStartRetrievalTest = () => {
  return useMutation({
    mutationFn: (variables: {
      companyId: number;
      questionListId: number;
      configOverrides: Record<string, number | boolean | string>;
      groundTruth?: Record<string, unknown> | null;
    }) =>
      startRetrievalTest(
        variables.companyId,
        variables.questionListId,
        variables.configOverrides,
        variables.groundTruth
      ),
  });
};

export const useRetrievalTestStatus = (
  testId: string | null,
  enabled: boolean
) => {
  return useQuery<RetrievalTestStatusResponse, Error>({
    queryKey: ["retrievalTestStatus", testId],
    queryFn: () => getRetrievalTestStatus(testId!),
    enabled: enabled && !!testId,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === "completed" || status === "error") {
        return false;
      }
      return 3000;
    },
    gcTime: 0,
    staleTime: 0,
  });
};

export const useStartGridSearch = () => {
  return useMutation({
    mutationFn: (variables: {
      companyId: number;
      questionListId: number;
      paramGrid: Record<string, (number | boolean | string)[]>;
      groundTruth?: Record<string, unknown> | null;
    }) =>
      startGridSearch(
        variables.companyId,
        variables.questionListId,
        variables.paramGrid,
        variables.groundTruth
      ),
  });
};

export const useGridSearchStatus = (
  testId: string | null,
  enabled: boolean
) => {
  return useQuery<GridSearchStatusResponse, Error>({
    queryKey: ["gridSearchStatus", testId],
    queryFn: () => getGridSearchStatus(testId!),
    enabled: enabled && !!testId,
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      if (status === "completed" || status === "error") {
        return false;
      }
      return 5000;
    },
    gcTime: 0,
    staleTime: 0,
  });
};
